import { LoginUseCase } from "@karma-games/angular-devkit/src/lib/modules/authentication";
import { firstValueFrom, tap, timer } from "rxjs";
import { GetConfigUseCase } from "./core/config/get-config.use-case";
import { GetUserUseCase } from "@karma-games/angular-devkit/src/lib/modules/user";
import { getUrlParam } from "@karma-games/angular-devkit/src/lib/functions";
import { filter, switchMap, take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { GetUserLanguageUseCase, SetInitialSettingsUseCase } from "@karma-games/angular-devkit/src/lib/modules/settings";
import { LoadPixiAssetsUseCase } from "./game/domain/load-pixi-assets-use-case.service";
import { ImagePreloadingService } from "@karma-games/angular-devkit/src/lib/services/image-preloading";
import { SplashController } from "@karma-games/angular-devkit/src/lib/modules/splash";

export namespace AppInitializer {
    export function initializeApp(loginUseCase: LoginUseCase,
                                  getUserUseCase: GetUserUseCase,
                                  getConfigUseCase: GetConfigUseCase,
                                  getUserLanguageUseCase: GetUserLanguageUseCase,
                                  translate: TranslateService,
                                  imagePreloadingService: ImagePreloadingService,
                                  setInitialSettingsUseCase: SetInitialSettingsUseCase,
                                  loadGameAssetsUseCase: LoadPixiAssetsUseCase): () => Promise<void> {
        return (): Promise<void> => {
            return new Promise<void>(async (resolve, reject) => {
                // Print build number in console
                console.warn("Angular build number: 5");

                // This is used for AudioContext reuse by Phaser
                window["PhaserGlobal"] = {};

                imagePreloadingService.preload(["assets/images/error-page/croco_character_error.png"]);

                const sessionToken: string | null = "ea719addd13d4616914a835900c47ec81182fb2f8d5943e3b1b743e8935b9fc3"; //getUrlParam("sessionToken");
                const lang: string | null = getUrlParam("language");
                if (lang) {
                    setInitialSettingsUseCase.execute({ lang });
                }
                loginUseCase.execute({ sessionToken: <string>sessionToken });
                const splashController: SplashController = new SplashController();
                try {
                    await Promise.all([
                        getConfigUseCase.execute(),
                        loadGameAssetsUseCase.execute(),
                        firstValueFrom(getUserUseCase.execute()
                            .pipe(tap(() => splashController.setProgress(90)), switchMap(() => getUserLanguageUseCase.execute()
                                .pipe(tap(() => splashController.setProgress(100)), filter(lang => !!lang), take(1),
                                    switchMap((language: string) => translate.use(language).pipe(take(1))))),
                            ))
                    ]);
                } catch (e) {
                    console.error(e);
                    translate.use("bg").pipe(take(1));
                    reject(e);
                }
                timer(500).subscribe(() => {
                    resolve();
                });
            });
        };
    }
}
